import React, { useState } from 'react';

import { Button } from '@mui/material';

import ProviderLogo from './ProviderLogo';
import OrderButton from './OrderButton';
import OfferDetailsPopup from './OfferDetailsPopup';

import './FeaturedOffer.css';

function FeaturedOffer({ offer, priceColumn, usage, usageSetting }) {
  const [showOfferDetails, setShowOfferDetails] = useState(null);

  return (
    <li className="featured-offer">
      <div className="content">
        <h4 style={{ backgroundColor: offer.color }}>{offer.label}</h4>
        <h5 className="offer-name">{offer.DisplayName}</h5>

        <div className="price-container">
          {priceColumn === 'TrueCost_Dollars' ? (
            <div className="price">
              {offer.TrueCost_PerKWh.toFixed(1)}
              <sup>¢</sup>
            </div>
          ) : (
            <div className="price">
              {offer.SingleMonthPriceKWh.toFixed(1)}
              <sup>¢</sup>
            </div>
          )}

          <div className="usage">
            average price {priceColumn === 'TrueCost_Dollars' ? ' a ' : ''}
            <br />
            {priceColumn === 'TrueCost_Dollars'
              ? ' seasonal average of ' + usage + ' kWh'
              : ' at ' + usage + ' kWh'}
            <div className="plan-details-mobile">
              <Button onClick={() => setShowOfferDetails(true)}>
                view plan details
              </Button>
            </div>
          </div>
        </div>

        <div className="logo-action">
          <ProviderLogo offer={offer} />
          <div className="action">
            <OrderButton offer={offer} />
          </div>
        </div>

        <h5 className="offer-name-mobile">{offer.DisplayName}</h5>
        <div className="plan-details">
          <Button onClick={() => setShowOfferDetails(true)}>
            View Plan Details
          </Button>
        </div>
      </div>

      {showOfferDetails ? (
        <OfferDetailsPopup
          offer={offer}
          closeFunc={() => setShowOfferDetails(null)}
          selectedUsage={usage}
          usageSetting={usageSetting}
        />
      ) : null}
    </li>
  );
}

export default FeaturedOffer;
